import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DiagnoseTemplateBusinessService } from 'projects/Administration/src/app/business-services/diagnose-template.service';
import { BaseService } from 'projects/Autofacets-Core/src/app/services/base.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { CurrentLanguage } from '../../../../../../../../Autofacets-Core/src/app/common-services/current-language.service';
@Component({
  selector: 'app-add-diagnose-template',
  templateUrl: './add-diagnose-template.component.html'
})
export class AddDiagnoseTemplateComponent implements OnInit {
  addDiagnoseTemplate = false;
  addDiagnoseTemplateForm: FormGroup;
  templateType = [{id:1,name:"Diagnose"},{id:2,name:"Cause"},
              {id:3,name:"Solution and Result"},{id:4,name:"Cause Code"}]
  languageList: any[];
  constructor(
    private activeModal : NgbActiveModal,
    private formBuilder: FormBuilder,
    private toaster: ToastrService,
    private translate: TranslateService,
    private baseService: BaseService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private diagnoseTemplateService: DiagnoseTemplateBusinessService,
    private currentLanguageService: CurrentLanguage,
    private userService: UserDataService,
  ) { }

  ngOnInit(): void {
    this.languageList = this.currentLanguageService.LanguageList;
    this.addDiagnoseTemplateForm = this.formBuilder.group({
      templateId: [null, [Validators.required]],
      service: new FormArray([]),
      isActive:[true]
    });
    this.getLanguage();
  }
  get t() { return this.cpf.service as FormArray; }
  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
        for (let i = this.t.length; i < number; i++) {
            this.t.push(this.formBuilder.group({
                languageId: ['',],
                name: ['', Validators.required],
                description: ['', Validators.required],
            }));
        }
    } else {
        for (let i = this.t.length; i >= number; i--) {
            this.t.removeAt(i);
        }
    }
}
OnClose(){
  this.activeModal.close({success:false})
}

  addDiagnoseTemplates()
  {
    this.spinner.show();
    let viweModel = {
      isActive:  this.addDiagnoseTemplateForm.value.isActive,
      templateId: this.addDiagnoseTemplateForm.value.templateId,
      lnlnvalue: this.addDiagnoseTemplateForm.value.service,
      currentUser:this.userService.currentUserValue.userId,
      id:0
    }
    this.diagnoseTemplateService.addDiagnoseTemplate(viweModel).then(res => {
      if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
        this.activeModal.close({ success: true
        });
        let successMsg = this.translate.instant("lblDiagnoseTemplateAdded");
        this.toaster.success(successMsg);
      }
      else if (res.responseCode === Enums.ErrorCodes.RentalCarAlreadyAdded) {
        this.spinner.hide();
        let errorErr = this.translate.instant("lblDiagnoseTemplateExist");
        this.toaster.warning(errorErr);
      }
    });
    this.spinner.hide();
  }
  get cpf() {
    return this.addDiagnoseTemplateForm.controls;
  }
}
